import axios from "axios";
import axiosInstance, { BASE_URL } from "../../utils/config/config";

export const createUser = async (userData) => {
  try {
    const response = await axios.post(`${BASE_URL}/user/register`, {
      email: userData.email,
      password: userData.password,
      firstName: userData.firstName,
      lastName: userData.lastName,
      userType: userData.userType,
    });

    localStorage.setItem("authToken", response.data.accessToken);

    return response.data;
  } catch (error) {
    console.error("Failed to create user", error);
    return error;
  }
};

export const loginUser = async (userData) => {
  try {
    const response = await axios.post(`${BASE_URL}/user/login`, {
      email: userData.email,
      password: userData.password,
    });

    if (!response.data.UserId) {
      localStorage.setItem("authToken", response.data.accessToken);
    }

    return response.data;
  } catch (error) {
    console.error("Failed to login user", error);
    return error;
  }
};

export const verifyMfa = async (id, code) => {
  try {
    const response = await axios.post(`${BASE_URL}/user/verify-mfa`, {
      userId: id,
      code: code,
    });

    localStorage.setItem("authToken", response.data.accessToken);

    return response.data;
  } catch (error) {
    console.error("Failed to login user", error);
    return error;
  }
};

export const getUserById =
  (userId = "") =>
  async (dispatch) => {
    try {
      dispatch({
        type: "userByIdRequest",
      });
      const { data } = await axiosInstance.get(
        `/user/getSpecificUser?userId=${userId}`
      );
      dispatch({
        type: "userByIdSuccess",
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: "userByIdFailure",
        payload: error,
      });
    }
  };

export const UpdateUser = async (userData, autoMessage) => {
  try {
    const response = await axiosInstance.put(`/user/updateUser`, {
      user: {
        userId: userData.userId,
        email: userData.email,
        firstName: userData.firstName,
        bankName: userData.bankName,
        iban: userData.iban,
        youtube: userData.youtubeUrl,
        tiktokUrl: userData.tiktokUrl,
        twitterUrl: userData.twitterUrl,
        instagram: userData.instagram,
        lastName: userData.lastName,
        subscriptionPlan: userData.subscription,
        bio: userData.bio,
        userType: userData.userType,
        avatar: userData.avatar,
        MfaEnabled: userData.mfaEnabled,
        messagingEnabled: userData.messagingEnabled,
        autoMessagingEnabled: userData.autoMessagingEnabled,
      },

      autoMessages: autoMessage,
    });

    return response.data;
  } catch (error) {
    console.error("Failed to update user", error);
    return null;
  }
};

export const followCreator = async (id) => {
  try {
    const response = await axiosInstance.post("/user/followCreator", {
      id: id,
    });

    if (response.status === 200) {
      return true;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
};
export const unFollowCreator = async (id) => {
  try {
    const response = await axiosInstance.post("/user/unfollowCreator", {
      id: id,
    });
    if (response.status === 200) {
      return true;
    }
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getCreatorsSubscribed = () => async (dispatch) => {
  try {
    dispatch({
      type: "creatorSubscribedRequest",
    });
    const { data } = await axiosInstance.get(`/user/getSubscribedUsers`);
    dispatch({
      type: "creatorSubscribedSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "creatorSubscribedFailure",
      payload: error,
    });
  }
};

export const getAllCreators = () => async (dispatch) => {
  try {
    dispatch({
      type: "getAllCreatorsRequest",
    });
    const { data } = await axiosInstance.get(`/user/getAllCreators`);
    dispatch({
      type: "getAllCreatorsSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "getAllCreatorsFailure",
      payload: error,
    });
  }
};

export const subscribeCreator = async (
  creatorId,
  packageId,
  paymentMethodId
) => {
  try {
    const response = await axiosInstance.post(`/user/subscribe`, {
      creatorId,
      packageId,
      paymentMethodId,
    });

    return response.data;
  } catch (error) {
    console.error("Failed to subscribe to creator", error);
    return null;
  }
};
export const unSubscribeCreator = async (creatorId) => {
  try {
    const response = await axiosInstance.delete(
      `/user/unsubscribe?creatorId=${creatorId}`,
      {
        creatorId,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Failed to unsubscribe creator", error);
    return null;
  }
};

export const createExerciseEvent = async (eventData) => {
  try {
    const response = await axiosInstance.post(
      "/exerciseevent/createExerciseEvent",
      {
        eventData,
      }
    );
  } catch (err) {
    console.log("Failed to create exercise event", err);
    return null;
  }
};
export const updateExerciseEvent = async (eventId, eventData) => {
  try {
    const response = await axiosInstance.put(
      `/exerciseevent/updateEvent/${eventId}`,
      {
        eventData,
      }
    );
  } catch (err) {
    console.log("Failed to create exercise event", err);
    return null;
  }
};

export const clearUserData = () => async (dispatch) => {
  try {
    dispatch({
      type: "clearUserData",
    });
  } catch (error) {}
};
export const profileVisit = async (userId) => {
  try {
    const response = await axiosInstance.post(`/user/markProfileViewed`, {
      userId,
    });
    return response;
  } catch (error) {
    console.log("err", error);
    return error;
  }
};
